module.exports = __webpack_public_path__ + "assets/img/advantage-list-style.3e5f322f.svg";